import configs from '~/env.json'
import mixTheme, * as Themes from '~/assets/styles'
import {
  boticarioTheme,
  quemDisseBereniceTheme,
  vultTheme,
  eudoraTheme,
  gbInstitucionalTheme
} from '@grupoboticario/flora'

const defaultBranch = configs?.REACT_APP_BRANCH || 'BOT'

const floraThemes = {
  BOT: boticarioTheme,
  QDB: quemDisseBereniceTheme,
  VULT: vultTheme,
  EUD: eudoraTheme,
  DEFAULT: gbInstitucionalTheme
}

// PRD: campaign.branch defines the brand (white-label). Local: REACT_APP_BRANCH for local preview.
function selectBranch(campaignBranch) {
  if (configs.NODE_ENV !== 'production') {
    return defaultBranch
  }

  return campaignBranch || defaultBranch
}

/**
 * Gets the Material-UI theme options with customizations for the specified brand
 * @param {string} branch - Brand/branch to get theme for
 * @param {Object} previewLayoutCampaign - Preview layout theme customizations (takes precedence over layout)
 * @param {Object} layout - Default layout theme customizations
 * @returns {Object} Combined theme object for Material-UI
 */
export function getMuiThemeOptions(branch, previewLayoutCampaign, layout) {
  const selectedBranch = selectBranch(branch)
  const themeSource = previewLayoutCampaign || layout || Themes.defaultLayout(selectedBranch)
  return mixTheme(Themes[selectedBranch], themeSource)
}

/**
 * Resolves the Flora theme for the specified brand.
 * Pass the result as `theme` to FloraProvider so tokens cascade to the tree,
 * including Modal/Drawer content portaled via useFloraPortalContainer.
 * @param {string} branch - Brand/branch to get theme for
 * @returns {Object} Flora theme object
 */
export function getFloraThemeOptions(branch) {
  const selectedBranch = selectBranch(branch)
  return floraThemes[selectedBranch] || floraThemes.DEFAULT
}
